// Expanding search-bar component

// To-Do:
// - Write markup as partial
// - Write js
//  - Animate width
//  - Make use of overflow

function searchBar( sectionSelector, searchButton, attribute = 'height' ) {
  let searchSection = document.querySelector( sectionSelector );
  let searchBtn = document.querySelector( searchButton );
  let attr = attribute;
  if( searchSection ) {
    // console.log( 'works' );
    searchBtn.addEventListener( 'click', () => {
      let size;
      if ( attr == 'height' || attr === undefined ) {
        size = searchSection.scrollHeight
        if( searchSection.classList.contains( 'js--search-toggle' ) ) {
          searchSection.setAttribute( "style", `${attr}: ${size}px` );
        } else {
          searchSection.setAttribute( "style", `${attr}: 0px` );
        }
      } else if ( attr == 'width' ) {
        size = searchSection.scrollWidth
        size += 200
        if( searchSection.classList.contains( 'js--search-toggle' ) ) {
          searchSection.setAttribute( "style", `${attr}: ${size}px` );
        } else {
          searchSection.setAttribute( "style", `${attr}: 0px` );
        }
      }
      // console.log( size );
      searchSection.classList.toggle( 'js--search-toggle' );

    } )
  }
}


let searchHeader = searchBar( '.search-form--header', '.js--search-header', 'width' );

let searchNav = searchBar( '.search-form--nav', '.js--search-nav', 'width' );
